var map = {
	"./Home.vue": [
		8561,
		196,
		683
	],
	"./Order.vue": [
		8369,
		196,
		168,
		603,
		355
	],
	"./Orders.vue": [
		8150,
		196,
		168,
		603,
		686
	],
	"./Pending.vue": [
		40,
		196,
		168,
		401
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2513;
module.exports = webpackAsyncContext;